import {useEffect,useRef,useState} from "react";
import {api,errMsg} from "@/lib/api";
import PresenceDetector from "./PresenceDetector";

export default function SensorPreview({direct=false}={}){
 const [camera,setCamera]=useState(false),[mic,setMic]=useState(false),[armed,setArmed]=useState(false);
 const [level,setLevel]=useState(0),[motion,setMotion]=useState(0),[error,setError]=useState("");
 const video=useRef(null),resources=useRef({}),generation=useRef({camera:0,mic:0}),enabled=useRef(false),lastEvent=useRef({});
 enabled.current=armed;
 const stop=kind=>{
  generation.current[kind]++;
  const r=resources.current[kind];delete resources.current[kind];
  r?.stream?.getTracks().forEach(t=>t.stop());clearInterval(r?.timer);r?.audio?.close().catch(()=>{});
  if(kind==="camera"){if(video.current)video.current.srcObject=null;setCamera(false);setMotion(0);}
  else{setMic(false);setLevel(0);}
 };
 useEffect(()=>{
  const hide=()=>{if(document.hidden){stop("camera");stop("mic");setArmed(false);}};
  document.addEventListener("visibilitychange",hide);
  return()=>{document.removeEventListener("visibilitychange",hide);stop("camera");stop("mic");};
  // Resources are stopped on hide/unmount, including pending permission requests.
  // eslint-disable-next-line react-hooks/exhaustive-deps
 },[]);
 const emit=(kind,value)=>{
  if(!enabled.current||Date.now()-(lastEvent.current[kind]||0)<15000)return;
  lastEvent.current[kind]=Date.now();
  api.post("/assistant/events",{kind,title:kind==="noise_peak"?"Pico de nivel de audio":kind==="person_presence"?"Posible presencia detectada":"Cambio visual detectado",value})
    .catch(e=>setError(errMsg(e)));
 };
 const start=async kind=>{
  stop(kind);setError("");
  const token=++generation.current[kind];
  try{
   if(!navigator.mediaDevices?.getUserMedia)throw new Error("La cámara y el micrófono requieren un navegador y una conexión seguros.");
   const stream=await navigator.mediaDevices.getUserMedia(kind==="camera"?{video:{width:320,height:240,frameRate:4},audio:false}:{audio:true,video:false});
   if(generation.current[kind]!==token||document.hidden){stream.getTracks().forEach(t=>t.stop());return;}
   const r={stream};resources.current[kind]=r;
   if(kind==="camera"){
    setCamera(true);video.current.srcObject=stream;await video.current.play();
    if(generation.current[kind]!==token)return;
    const canvas=document.createElement("canvas");canvas.width=32;canvas.height=24;
    const ctx=canvas.getContext("2d",{willReadFrequently:true});let previous=null;
    r.timer=setInterval(()=>{
     if(!video.current||video.current.readyState<2)return;
     ctx.drawImage(video.current,0,0,32,24);const data=ctx.getImageData(0,0,32,24).data;
     if(previous){let delta=0;for(let i=0;i<data.length;i+=4)delta+=Math.abs(data[i]-previous[i])+Math.abs(data[i+1]-previous[i+1])+Math.abs(data[i+2]-previous[i+2]);
      const score=delta/(32*24*3*255)*100;setMotion(Math.round(score));if(score>12)emit("camera_motion",score);}
     previous=new Uint8ClampedArray(data);
    },500);
   }else{
    const Audio=window.AudioContext||window.webkitAudioContext;
    const audio=new Audio();r.audio=audio;await audio.resume();
    if(generation.current[kind]!==token)return;
    const analyser=audio.createAnalyser();analyser.fftSize=1024;
    audio.createMediaStreamSource(stream).connect(analyser);
    const values=new Uint8Array(analyser.fftSize);
    r.timer=setInterval(()=>{analyser.getByteTimeDomainData(values);const rms=Math.sqrt(values.reduce((s,n)=>s+((n-128)/128)**2,0)/values.length);
     setLevel(Math.round(rms*100));if(rms>.3)emit("noise_peak",Math.round(rms*100));},200);
    setMic(true);
   }
  }catch(e){if(generation.current[kind]!==token)return;stop(kind);setError(e?.name==="NotAllowedError"?"Permiso denegado por el navegador.":e.message);}
 };
 return <section className="border border-cyan-500/20 p-4 space-y-3">
  <h3 className="text-cyan-200 font-hud">SENSORES LOCALES</h3>
  <p className="text-xs text-slate-400">Vista y medición en este dispositivo. No se guardan ni se envían imágenes o audio. Detecta cambios y nivel de sonido; no identifica personas, emociones, sueño ni palabras.</p>
  <video ref={video} muted playsInline className={camera?"w-full max-h-60 bg-black":"hidden"} aria-label="Vista previa de cámara"/>
  <div className="flex gap-3 flex-wrap">
   <button className="hud-button" onClick={()=>camera?stop("camera"):start("camera")}>{camera?"Detener cámara":"Activar cámara"}</button>
   <button className="hud-button" onClick={()=>mic?stop("mic"):start("mic")}>{mic?"Detener micrófono":"Activar micrófono"}</button>
  </div>
  <PresenceDetector camera={camera} video={video} onEvent={emit}/>
  <p className="text-xs">Cambios visuales: {motion}% · Nivel de audio: {level}%</p>
  <label className="flex gap-2 text-xs"><input type="checkbox" checked={armed} onChange={e=>setArmed(e.target.checked)}/>Enviar eventos de nivel y movimiento a mis reglas</label>
  <p className="text-xs text-slate-500">Se detienen al ocultar esta página. {direct?"Tus reglas habilitadas ejecutan sus acciones sin una segunda aprobación.":"Las acciones propuestas requieren confirmación."}</p>
  {error&&<p role="alert" className="text-amber-300 text-sm">{error}</p>}
 </section>;
}
